// src/utils/formatCurrency.js

/**
 * Format a number as USD with thousands separators and 2 decimals.
 * Always returns the digits only (no leading "$") so callers keep control
 * of where the symbol goes. Pass { symbol: true } to include it.
 *
 *   formatCurrency(1500)        -> "1,500.00"
 *   formatCurrency(1650.5)      -> "1,650.50"
 *   formatCurrency("550")       -> "550.00"
 *   formatCurrency(null)        -> "0.00"
 *   formatCurrency(1500, { symbol: true }) -> "$1,500.00"
 *   formatCurrency(1650, { decimals: 0 })  -> "1,650"
 */
export function formatCurrency(value, { symbol = false, decimals = 2 } = {}) {
  const n = parseFloat(value);
  const safe = Number.isFinite(n) ? n : 0;
  const formatted = safe.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return symbol ? `$${formatted}` : formatted;
}

// Compact form for summary chips like "$11.8k".
//   formatCompactCurrency(11800) -> "$11.8k"
//   formatCompactCurrency(950)   -> "$950"
export function formatCompactCurrency(value) {
  const n = parseFloat(value);
  const safe = Number.isFinite(n) ? n : 0;
  return `$${safe.toLocaleString("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  })}`;
}